function Point(
    { 
        zoom,
        orgCount = 0, 
        compCount = 0, 
        isMixed = false, 
        isCompany = false,
        isRMR = false
    }: { 
        zoom?: number; 
        orgCount?: number;
        compCount?: number;
        isMixed?: boolean; 
        isCompany?: boolean;
        isRMR?: boolean;
    }
) {
    const minZoom = 0;
    const maxZoom = 13;
    const minScale = 0.5;
    const maxScale = 1;

    const scale = zoom
        ? Math.min(
              maxScale,
              Math.max(
                  minScale +
                      ((zoom - minZoom) * (maxScale - minScale)) /
                          (maxZoom - minZoom),
                  minScale
              )
          )
        : 1;

    const entitiesCount = orgCount + compCount;

    const isCluster = entitiesCount && entitiesCount > 1;

    return (
        <button
            className={`point ${isMixed ? 'compatible' : isCompany ? 'company' : isRMR ? 'rmr' : ''}`}
            style={{
                transform: `
                  translateY(${(1 - scale) * 12}px)
                  scale(${scale})
                  rotate(-45deg)
                `,
            }}
        >
            <div className="point__wrapper">
                {isCluster ? (
                    <span className="point__count">{entitiesCount}</span>
                ) : (
                    isCompany  ? <ion-icon name="briefcase"></ion-icon>
                    : isRMR ? <ion-icon name="business"></ion-icon> 
                    : <ion-icon name="school"></ion-icon>
                )}
            </div>
        </button>
    );
}

export default Point;
